import type { RouteConfig } from 'vue-router';
import { Role } from '@/modules/shared/types';
import { licenseAccountingIsEnabled } from '@/plugins/config';

const route: RouteConfig = {
    path: '/:customer/account-groups',
    name: 'admin-account-groups',
    component: () => import(/* webpackChunkName: "ctx-admin-accounting" */ './AccountGroups.vue'),
    meta: {
        role: Role.APP_ADMIN,
        license: [],
        authenticated: true,
        settingsTabs: licenseAccountingIsEnabled,
        settingsTabsGroup: 'company-admin',
        portfolioTabs: false,
        navbar: true,
        footer: true,
        onboarding: true,
        notifications: true,
    },
};

export { route };
